import React from 'react';
import { Box } from '@rebass/grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import styled from 'styled-components';
import { colors } from '../../config/theme';

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${colors.textPrimary};
  height: 60px;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  padding: 0 8px 0 16px;
  box-sizing: border-box;
`;

const Content = styled.div`
  padding: 8px 16px 24px;
  overflow-wrap: break-word;
  word-break: break-word;
`;

const BottomSheet = ({ open, onClose, title, children }) => {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen
      PaperProps={{
        style: {
          borderRadius: '20px 20px 0 0',
          background: colors.surface,
          maxHeight: '85vh',
          overflowX: 'hidden',
          overflowY: 'auto',
        },
      }}
      transitionDuration={{ enter: 300, exit: 250 }}
    >
      <Header>
        <Typography variant="subtitle1">{title}</Typography>
        <IconButton onClick={onClose} size="small">
          <Close style={{ color: colors.textPrimary }} />
        </IconButton>
      </Header>
      <Content>
        <Box>{children}</Box>
      </Content>
    </SwipeableDrawer>
  );
};

export default BottomSheet;
